import React from "react";

const Home = () => {
  return (
    <div>
      <h1>This Is Home</h1>
    </div>
  );
};

export default Home;
